import { useState } from "react";
import { Modal, Button } from "react-bootstrap";

const DashboardLegendModal = () => {
  const [show, setShow] = useState(false);

  return (
    <>
      <Button
        variant="outline-secondary"
        size="sm"
        className="rounded-circle ms-2 py-0 px-2"
        style={{ lineHeight: "1.4" }}
        onClick={() => setShow(true)}
        aria-label="Show legend"
      >
        ?
      </Button>

      <Modal show={show} onHide={() => setShow(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Dashboard legend</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h6 className="fw-semibold">Adherence fraction</h6>
          <p className="small mb-1">
            Shows how many days out of the week (or meals out of 21 for nutrition) a goal was met.
          </p>
          <table className="table table-sm table-bordered small mb-3">
            <thead className="table-light">
              <tr>
                <th>Metric</th>
                <th className="text-danger">Red threshold</th>
              </tr>
            </thead>
            <tbody>
              <tr><td>Activity</td><td>≤ 5/7</td></tr>
              <tr><td>Sleep</td><td>≤ 5/7</td></tr>
              <tr><td>Weight</td><td>≤ 1/7</td></tr>
              <tr><td>Nutrition</td><td>≤ 15/21</td></tr>
              <tr><td>Glucose</td><td>≤ 1/7</td></tr>
              <tr><td>Blood pressure</td><td>≤ 1/7</td></tr>
            </tbody>
          </table>

          <h6 className="fw-semibold">Average value stoplight</h6>
          <p className="small mb-1">
            Colors the average reading shown below each fraction.
          </p>
          <table className="table table-sm table-bordered small mb-0">
            <thead className="table-light">
              <tr>
                <th>Metric</th>
                <th className="text-success">Green (optimal)</th>
                <th className="text-warning">Yellow (borderline)</th>
                <th className="text-danger">Red (alert)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Steps</td>
                <td>≥ 7,000</td>
                <td>4,000 – 6,999</td>
                <td>&lt; 4,000</td>
              </tr>
              <tr>
                <td>Sleep</td>
                <td>7 h – 9 h</td>
                <td>5 h – 6:59 h · 9 h – 10 h</td>
                <td>&lt; 5 h · &gt; 10 h</td>
              </tr>
              <tr>
                <td>BMI</td>
                <td>18.5 – 25</td>
                <td>25 – 30</td>
                <td>&lt; 18.5 · &gt; 30</td>
              </tr>
              <tr>
                <td>Nutrition avg</td>
                <td>≥ 2.5</td>
                <td>1.5 – 2.49</td>
                <td>&lt; 1.5</td>
              </tr>
              <tr>
                <td>Glucose (mg/dL)</td>
                <td>&lt; 100</td>
                <td>100 – 120</td>
                <td>&gt; 120</td>
              </tr>
              <tr>
                <td>Blood pressure (mmHg)</td>
                <td>&lt; 120 / 80</td>
                <td>120–140 / 80–90</td>
                <td>&gt; 140 / 90</td>
              </tr>
            </tbody>
          </table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShow(false)}>Close</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default DashboardLegendModal;
